/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import LoadingPage from '../../pages/LoadingPage';
import { maskPercent } from '../../utils/masks';

const SummaryReportTable = ({ listItem = null }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Conversão</TableCell>
            <TableCell align="center">Porcentagem</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listItem &&
            listItem?.map((item, index) => (
              <TableRow key={index}>
                <TableCell align="left">{item?.type}</TableCell>
                <TableCell align="center">{item?.percent}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SummaryReportTable;
